import { FunnelChart } from '@wundo/ui';
import type { MetricDataPoint } from '@/lib/dashboard.ts';
import { ChartCard } from './ChartCard.tsx';
import { METRIC_INFO } from './metricsInfo.ts';
import { formatPct, sumPoints } from './funnelMath.ts';

export interface NudgeFunnelCardProps {
  shown: MetricDataPoint[];
  clicked: MetricDataPoint[];
  dismissed: MetricDataPoint[];
  completed: MetricDataPoint[];
}

/**
 * What onboarding nudges lead to over the selected period.
 *
 * Dismissal sits beside the funnel rather than in it: it is a way *out* of the
 * chain, and a bar between Clicked and Completed would read as a step on the
 * way there. Its rate is against Shown, like every other rate here.
 */
export function NudgeFunnelCard(props: NudgeFunnelCardProps) {
  const shown = sumPoints(props.shown);
  const clicked = sumPoints(props.clicked);
  const dismissed = sumPoints(props.dismissed);
  const completed = sumPoints(props.completed);

  return (
    <ChartCard
      title='Onboarding nudge funnel'
      info={METRIC_INFO.nudgeFunnel}
      description={
        'Shown → Clicked → Completed. Shown is counted once per person per nudge; clicking and ' +
        'dismissing are counted every time.'
      }
      aside={
        <p className='text-xs text-ink-muted'>
          {`Dismissed ${dismissed} · ${formatPct(dismissed, shown)} of shown`}
        </p>
      }
    >
      <FunnelChart
        ariaLabel='Onboarding nudge funnel'
        steps={[
          { label: 'Shown', value: shown, hint: 'Once per person per nudge' },
          { label: 'Clicked', value: clicked, hint: 'Every click counts' },
          {
            label: 'Completed',
            value: completed,
            hint: `${formatPct(completed, shown)} of shown`,
          },
        ]}
      />
    </ChartCard>
  );
}
